import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function PortalScrollReset() {
  const { pathname, hash } = useLocation();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    const pathnameChanged = previousPathname.current !== pathname;
    previousPathname.current = pathname;

    if (pathnameChanged && !hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
